import React, { FC } from 'react';

import config from '@constants/config';
import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useFetchCashiers } from '@shared/hooks';

const { TRANSFERS_REPORT_VERSION } = config;

interface CashierSelectorProps {
  subsidiary?: number;
  roleName?: string;
  disabled?: boolean;
  onSearch: (key: string, value: string | number | null) => void;
}

interface CashierOption {
  name: string;
  profile_id: number;
  mail: string;
}
const CashierSelector: FC<CashierSelectorProps> = ({ subsidiary = '', roleName = '', onSearch, disabled = false }) => {
  const options: CashierOption[] = useFetchCashiers(subsidiary, roleName);

  const handleAutocompleteChange = (value: CashierOption | null) => {
    if (!value) {
      onSearch('profile_id', null);
      if (TRANSFERS_REPORT_VERSION === '2') {
        onSearch('cashier_name', '');
      }
      return;
    }
    onSearch('profile_id', value.profile_id);
    if (TRANSFERS_REPORT_VERSION === '2') {
      onSearch('cashier_name', value.mail);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const textPattern = /^[A-Za-záéíóúÁÉÍÓÚñÑ\s]*$/;

    if (value && !textPattern.test(value)) {
      event.preventDefault();
      return false;
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const textPattern = /^[A-Za-záéíóúÁÉÍÓÚñÑ\s]$/;
    const key = event.key;

    // Permitir teclas de control (backspace, delete, arrow keys, etc.)
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      key === 'Backspace' ||
      key === 'Delete' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Tab' ||
      key === 'Enter' ||
      key === 'Escape'
    ) {
      return;
    }

    // Bloquear si no es una letra (con acentos) o espacio
    if (!textPattern.test(key)) {
      event.preventDefault();
    }
  };

  return (
    <Autocomplete
      options={options}
      disabled={disabled}
      getOptionLabel={(option) => option.name ?? ''}
      isOptionEqualToValue={(option, value) => option.profile_id === value?.profile_id}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Cajero"
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#fff',
              borderRadius: '12px',
            },
          }}
        />
      )}
      onChange={(event, value) => handleAutocompleteChange(value)}
    />
  );
};

export default CashierSelector;
